import auth from 'app/auth/store/reducers';
import { combineReducers } from 'redux';
import fuse from './fuse';
import brands from './brands';
import countries from './countries';
import departments from './departments';
import cache from './cacheReducer';

const createReducer = asyncReducers =>
  combineReducers({
    auth,
    fuse,
    brands,
    countries,
    departments,
    cache,
    ...asyncReducers
  });

export default createReducer;
